import { useAppSelector, useAppDispatch, raceActions } from '../store/index'

export function useTimer() {
  const dispatch = useAppDispatch()
  const timer = useAppSelector(state => state.race.timer)

  const start = (legStartTime: string) => {
    dispatch(raceActions.startTimer(legStartTime))
  }

  const stop = () => {
    dispatch(raceActions.stopTimer())
  }

  const reset = () => {
    dispatch(raceActions.resetTimer())
  }

  return {
    ...timer,
    start,
    stop,
    reset,
  }
}
